import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Card } from "@/components/ui/card";

interface QRCodeDisplayProps {
  qrCodeData: string;
}

export const QRCodeDisplay = ({ qrCodeData }: QRCodeDisplayProps) => {
  if (!qrCodeData) return null;

  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <QRCodeSVG value={qrCodeData} size={256} />
      <p className="text-sm text-gray-500 text-center mt-4">
        Abra o WhatsApp no seu celular e escaneie o QR Code para conectar
      </p>
    </div>
  );
};